import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services';
import {
  ITripsFilters,
  emptyTripsFilters,
  parseTripsFiltersFromStorage,
  serializeTripsFilters,
} from '../filters';

/**
 * Hydrates the URL from localStorage *before* the resolver runs, so the data
 * fetch happens only once per sidebar entry. See {@link bookingsHydrationGuard}.
 */
export const tripsHydrationGuard: CanActivateFn = async (route, state) => {
  if (route.queryParamMap.keys.length > 0) return true;

  const storage = inject(StorageService);
  const router = inject(Router);

  const storedFilters = parseTripsFiltersFromStorage(await storage.getTripsFilters());

  const filters: ITripsFilters = storedFilters ?? emptyTripsFilters();
  const serialized = serializeTripsFilters(filters);
  const queryParams: { [key: string]: string | number } = {};
  for (const [k, v] of Object.entries(serialized)) {
    if (v != null && v !== '') queryParams[k] = v as string;
  }
  if (Object.keys(queryParams).length === 0) return true;

  const path = state.url.split('?')[0];
  return router.createUrlTree([path], { queryParams });
};
